var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    fill: "none",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M86 53l7-6.5 28.5 1 68 71.5-14 29-55.5 39.5-27-17L86 53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4511E",
    d: "M211 110.5L129.5 29c-2.5-2.5-6-4-9.5-4s-7 1.5-9.5 4L93 46.5 113.5 67c2-1 4-1.5 6.5-1.5 8.5 0 15 6.5 15 15 0 2.5-.5 4.5-1.5 6.5l20 20c2-1 4-1.5 6.5-1.5 8.5 0 15 6.5 15 15s-6.5 15-15 15-15-6.5-15-15c0-2.5.5-4.5 1.5-6.5l-20-20c-.5 0-1 .5-1.5.5v52c6 2 10 7.5 10 14 0 8.5-6.5 15-15 15s-15-6.5-15-15c0-6.5 4-12 10-14V94c-6-2-10-7.5-10-14 0-2.5.5-4.5 1.5-6.5L86 53l-57 57.5c-2.5 2.5-4 6-4 9.5s1.5 7 4 9.5l81.5 81.5c2.5 2.5 6 4 9.5 4s7-1.5 9.5-4l81.5-81.5c2.5-2.5 4-6 4-9.5s-1.5-7-4-9.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.cde7d18d7594418ac9244921c94e9af3.svg";
export { ForwardRef as ReactComponent };